document.addEventListener('DOMContentLoaded', function () {

    const dataMarquee = document.querySelectorAll('[data-marquee="true"]');

    const initSwiper = () => {
        

        dataMarquee.forEach(marquee => {
            let swiperContent = marquee.querySelector('.swiper-grid__container');
            let swiperWrapper = marquee.querySelector('.grid-container');
            let swiperSlides = marquee.querySelectorAll('.grid-item');

            if (window.innerWidth <= 767) {
                swiperContent.classList.add('swiper');
                swiperWrapper.classList.add('swiper-wrapper');
                swiperSlides.forEach((item) => {
                    item.classList.add('swiper-slide');
                })

                const swiper = new Swiper(swiperContent, {
                    loop: true,
                    speed: 2000,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    allowMouseEvents: false,
                    autoplay: {
                        delay: 0
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 4,
                            spaceBetween: 50
                        }
                    },
                });
            } else {
                swiperContent.classList.remove('swiper');
                swiperWrapper.classList.remove('swiper-wrapper');
                swiperSlides.forEach((item) => {
                    item.classList.remove('swiper-slide');
                })
            }
        });


    }

    initSwiper();

    window.addEventListener('resize', function() {
      initSwiper();
    });

});